import React, { Component } from 'react';
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Translate } from "react-localize-redux";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import SampleIcon from '@material-ui/icons/LocalShipping';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';

import SuppliersSelector from '../../common/SupplierSelector'
import SupplierByCompnaySelector from '../../common/SupplierByCompnaySelector'


/**
 * Memo item lateral options panels
 *
 * @class MemoItemDialog
 * @extends {Component}
 */
class MemoItemDialog extends Component {

    /**
     *Creates an instance of MemoItemDialog.
     * @param {*} props
     * @memberof MemoItemDialog
     */
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            suppliersSelected: []
        }
    }

    handleChangeIsQuoteOrSampleRequiredInState(supplierToken, isRequired, property) {
        let updatedSuppliers = [...this.state.suppliersSelected];
        let indexToUpdate = updatedSuppliers.findIndex(x => x.token === supplierToken);
        let updatedSupplier = { ...updatedSuppliers[indexToUpdate] };
        updatedSupplier[property] = isRequired;
        updatedSuppliers[indexToUpdate] = updatedSupplier;
        this.setState({ suppliersSelected: updatedSuppliers });
    }

    onRemoveNotificationSupplierClick(supplier) {
        if (this.props.onRemoveNoticeSupplier) {
            this.props.onRemoveNoticeSupplier(supplier.token)
                .then(() => {
                    this.setState({
                        suppliersSelected: this.state.suppliersSelected.filter(supplierSelected => supplierSelected.token !== supplier.token)
                    })
                })
        }
    }

    /**
     * On add sample request to supplier
     */
    onAddSampleRequestSupplierClick(supplier) {
        if (this.props.onAddSampleRequestSupplier) {
            this.props.onAddSampleRequestSupplier(supplier)
                .then(() => {
                    this.handleChangeIsQuoteOrSampleRequiredInState(supplier.token, true, "is_sample_requiered");
                })
        }
    }

    /**
     * On remove sample request to supplier
     */
    onRemoveSampleRequestSupplierClick(supplier) {
        if (this.props.onRemoveSampleRequestSupplier) {
            this.props.onRemoveSampleRequestSupplier(supplier.token)
                .then(() => {
                    this.handleChangeIsQuoteOrSampleRequiredInState(supplier.token, false, "is_sample_requiered");
                })
        }
    }

    onSupplierMemoSelected(supplier) {
        this.setState({
            suppliersSelected: this.state.suppliersSelected.concat(supplier)
        }, () => {
            this.props.onSupplierMemoSelected(null, supplier, true)
        });
    }

    /**
     *
     *
     * @memberof MemoItemDialog
     */
    getSelectedSuppliers() {
        const { classes } = this.props
        return this.state.suppliersSelected.length > 0 && this.state.suppliersSelected.map((supplier) => {
            return (
                <ListItem key={supplier && supplier.token} dense>
                    <ListItemText primary={supplier && supplier.name} />
                    <ListItemSecondaryAction>
                        {supplier &&
                            <Tooltip title={<Translate id={supplier.is_sample_requiered ?
                                "memos.removeRequestSampleTooltipMessage"
                                : "memos.requestSampleTooltipMessage"} />}>
                                <IconButton
                                    className={classes.sampleButton}
                                    color={supplier.is_sample_requiered ? "primary" : "default"}
                                    onClick={() => {
                                        supplier.is_sample_requiered ?
                                            this.onRemoveSampleRequestSupplierClick(supplier)
                                            : this.onAddSampleRequestSupplierClick(supplier)
                                    }}>
                                    <SampleIcon />
                                </IconButton>
                            </Tooltip>}
                        {supplier &&
                            <Tooltip title={<Translate id="memos.removeSupplierRequestTooltipMessage" />}>
                                <IconButton
                                    className={classes.deleteButton}
                                    onClick={() => { this.onRemoveNotificationSupplierClick(supplier) }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    </ListItemSecondaryAction>
                </ListItem >
            )
        })
    }

    /**
     *
     *
     * @returns
     * @memberof MemoItemDialog
     */
    render() {
        const { companyImbera } = this.props;
        return (
            <Dialog open={this.props.show} >
                <DialogTitle id="form-dialog-title">
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <Typography variant="caption" gutterBottom>
                                <Translate id="memos.addSupplierToMemoMessage" />
                            </Typography>
                            {!companyImbera && <SuppliersSelector
                                onSupplierSelected={(supplier) => { this.onSupplierMemoSelected(supplier) }}
                            />}
                            {companyImbera &&<SupplierByCompnaySelector
                                onSupplierSelected={(supplier) => { this.onSupplierMemoSelected(supplier) }}
                            />}
                            <List dense style={{ maxHeight: "30vh", overflowY: "auto" }}>
                                {this.getSelectedSuppliers()}
                            </List>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        <Translate id="common.close" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = theme => ({
    //SSM-0558-19
    deleteButton: {
        color: "red",
        maxWidth: 35,
        maxHeight: 35,
        paddingTop: 6,
        paddingLeft: 14
    },
    sampleButton: {
        maxWidth: 35,
        maxHeight: 35,
        paddingTop: 6,
        paddingLeft: 14
    }
})

export default withStyles(styles, { withTheme: true })(MemoItemDialog);